<app-left-menu [showMenu]="false"></app-left-menu>
<div id="main-container">

    <app-header [showHistoryButton]="true" [title]="title"></app-header>
    <div class="content-header"> </div>
    <div class="page-content settings">
        <div class="no-absolute " style="margin-top: 20px;">

            <div class="error-message" *ngIf="error">{{error}}</div>
            <form class="change-password" [formGroup]="changePasswordForm"
                (ngSubmit)="submitForm(changePasswordForm.value, changePasswordForm.valid)">
                <div class="error-message display-block">
                  
                    <span
                        *ngIf="!changePasswordForm.controls['newPassword'].errors?.required && (changePasswordForm.controls['newPassword'].errors?.minlength || changePasswordForm.controls['newPassword'].errors?.isValidPassword)">
                        {{'ChangePassword.New.Error.InValid'|translate}}</span>
                    <span style="color:green" *ngIf="changePasswordForm.controls['newPassword'].valid  ">
                        {{'ChangePassword.New.Error.Valid'|translate}}
                    </span>

                    <span
                        *ngIf="changePasswordForm.controls['newPassword'].valid && changePasswordForm.controls['confirmPassword'].touched && (changePasswordForm.controls['newPassword'].value != changePasswordForm.controls['confirmPassword'].value)">
                        {{'ChangePassword.Confirm.Error.MisMatch'|translate}}
                    </span>
                </div>

                <label>{{'ChangePassword.Old.Label'|translate}}<span class="required">*</span>

                </label>
                <input type="password" name="txtPassword" class="form-control"
                    [formControl]="changePasswordForm.controls['password']">

                <label>{{'ChangePassword.New.Label'|translate}}<span class="required">*</span></label>

                <input type="password" #password class="form-control" 
                    [formControl]="changePasswordForm.controls['newPassword']">
                <i class="fa fa-envelope icon" (click)="changeType()"></i>
                <label>{{'ChangePassword.Confirm.Label'|translate}}<span class="required">*</span></label>
                <input type="password" class="form-control" 
                    [formControl]="changePasswordForm.controls['confirmPassword']">
                    <div>

                        <span style="text-decoration: underline;"> {{'Common.PasswordMessage1'| translate}}</span>:
                        <br>-&nbsp;{{'Common.PasswordMessage2'| translate}}
                        <br>-&nbsp;{{'Common.PasswordMessage3'| translate}}
                        <br>-&nbsp;{{'Common.PasswordMessage4'| translate}}
                        <br>-&nbsp;{{'Common.PasswordMessage5'| translate}}
                        <br>-&nbsp;{{'Common.PasswordMessage6'| translate}}
                    </div>
                <button class="btn btn-main" [disabled]="!changePasswordForm.valid">{{'Common.Save'|translate}}</button>
            </form>
        </div>
    </div>
</div>